import { useMarketplaceLabel } from "../logistica/configurazione/marketplaceDisplay";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DataTable from "../interfaccia/DataTableBase";
import apiUrl from "../Apiurl";

function toInputDate(date) {
  return date.toISOString().slice(0, 10);
}

function getDefaultRange() {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
  return { dataStart: toInputDate(firstDay), dataEnd: toInputDate(lastDay) };
}

function formatDate(value) {
  return value ? String(value).slice(0, 10) : "";
}

function formatImporto(value) {
  return Number(value || 0).toLocaleString("it-IT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function FileControlliCell({ files }) {
  const routes = {
    AMAZON: "controlloCorrispettiviAmazon",
    PRESTASHOP: "controlloCorrispettiviPrestashop",
    GESTIONALE: "controlloCorrispettiviGestionale",
    DOMINO: "controlloCorrispettiviGestionale",
  };
  if (!Array.isArray(files) || files.length < 1) {
    return <span className="colScrittaDef-20">-</span>;
  }
  return (
    <div className="flex flex-column">
      {files.map((file) => {
        const route = routes[file.piattaforma];
        return route ? (
          <Link key={file.id} className="link dim mb1" to={`/${route}?fileId=${file.id}`}>
            {file.nomeFile}
          </Link>
        ) : <span key={file.id}>{file.nomeFile}</span>;
      })}
    </div>
  );
}

function ModalAggiuntaMassiva({
  dataStart,
  dataEnd,
  numeroRighe,
  analisi,
  analyzing,
  saving,
  errore,
  onAnalyze,
  onConfirm,
  onClose,
}) {
  const busy = analyzing || saving;
  return (
    <div className="modal" onClick={busy ? undefined : onClose}>
      <div
        id="modal-content"
        className="sfondoBiancoTema pa3 w-90 w-50-l"
        style={{
          maxHeight: "85vh",
          overflowY: "auto",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex justify-between items-center mb3">
          <div className="f4 b">Anteprima aggiunta eleggibili</div>
          <button className="dim tastoInputOrizzontale br3" type="button" onClick={onClose} disabled={busy}>CHIUDI</button>
        </div>
        <div className="mb3">
          L'operazione esaminera <b>{numeroRighe}</b> righe nel periodo dal <b>{formatDate(dataStart)}</b> al <b>{formatDate(dataEnd)}</b>.
          Le transazioni eleggibili verranno aggiunte al pool e confermate.
        </div>
        <div className="mb3">
          <div className="b mb2">Requisiti</div>
          <ul className="ma0 pl3">
            <li className="mb1">La transazione non deve essere gia confermata in un file di controllo.</li>
            <li className="mb1">Il movimento deve essere una spedizione o un rimborso.</li>
            <li className="mb1">Il marketplace deve essere valorizzato e diverso da Amazon.</li>
            <li className="mb1">L'importo deve essere diverso da zero.</li>
            <li className="mb1">Per le spedizioni, l'emissione scontrino deve essere impostata a SI.</li>
            <li>Gli ordini annullati in contrassegno o con bonifico non accreditato richiedono un rimborso equivalente.</li>
          </ul>
        </div>
        {errore && <div className="tastoRosso white pa2 br2 mb3">{errore}</div>}
        {analisi && (
          <div className="bt bordoColAlt pt3 mb3">
            <div className="flex flex-wrap mb3">
              <div className="mr4"><span className="b f4">{analisi.esaminate}</span><br /><span className="colScrittaDef-20">esaminate</span></div>
              <div className="mr4"><span className="b f4 green">{analisi.aggiungibili}</span><br /><span className="colScrittaDef-20">da aggiungere</span></div>
              <div><span className="b f4">{analisi.escluse}</span><br /><span className="colScrittaDef-20">ignorate</span></div>
            </div>
            <div className="b mb2">Righe ignorate dall'aggiunta, per motivo</div>
            {analisi.motiviEsclusione.length > 0 ? (
              <div>
                {analisi.motiviEsclusione.map((item) => (
                  <div className="flex justify-between items-center pv2 bb bordoColAlt" key={item.motivo}>
                    <span className="pr3">{item.motivo}</span>
                    <b>{item.numeroRighe}</b>
                  </div>
                ))}
                <div className="f7 colScrittaDef-20 mt2">Una riga puo presentare piu motivi. L'analisi non ne modifica lo stato.</div>
              </div>
            ) : (
              <div className="colScrittaDef-20">Nessuna riga ignorata.</div>
            )}
          </div>
        )}
        <div className="flex flex-wrap justify-end items-center">
          <button
            className="dim tastoInputOrizzontale br3 mr2 flex justify-center items-center"
            type="button"
            onClick={onAnalyze}
            disabled={busy || numeroRighe < 1}
          >
            <span className="material-symbols-outlined mr1">manage_search</span>
            {analyzing ? "ANALISI IN CORSO" : analisi ? "RIPETI ANALISI" : "ANALISI"}
          </button>
          <button
            className="tastoVerde white br2 ph2 pv1 flex justify-center items-center"
            type="button"
            onClick={onConfirm}
            disabled={busy || !analisi || analisi.aggiungibili < 1}
          >
            <span className="material-symbols-outlined mr1">playlist_add</span>
            {saving ? "APPLICO" : "APPLICA"}
          </button>
        </div>
      </div>
    </div>
  );
}

function TransazioniDominoCorrispettivi({ token }) {
  const marketplaceLabel = useMarketplaceLabel();
  const defaultRange = useMemo(getDefaultRange, []);
  const [dataStart, setDataStart] = useState(defaultRange.dataStart);
  const [dataEnd, setDataEnd] = useState(defaultRange.dataEnd);
  const [rows, setRows] = useState([]);
  const [rangeCaricato, setRangeCaricato] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");
  const [messaggio, setMessaggio] = useState("");
  const [righeInAggiunta, setRigheInAggiunta] = useState({});
  const [mostraAggiuntaMassiva, setMostraAggiuntaMassiva] = useState(false);
  const [aggiuntaMassivaInCorso, setAggiuntaMassivaInCorso] = useState(false);
  const [analisiMassiva, setAnalisiMassiva] = useState(null);
  const [analisiMassivaInCorso, setAnalisiMassivaInCorso] = useState(false);
  const [erroreAnalisiMassiva, setErroreAnalisiMassiva] = useState("");

  const loadData = useCallback(async () => {
    if (!token) return;
    if (!dataStart || !dataEnd || dataStart > dataEnd) {
      setErrore("Seleziona un intervallo date valido");
      return;
    }
    setLoading(true);
    setErrore("");
    setMessaggio("");
    try {
      const response = await axios.get(`${apiUrl}/contab/controlli-corrispettivi/transazioni-domino`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { dataStart, dataEnd },
      });
      setRows(response.data.data || []);
      setRangeCaricato({
        dataStart: response.data.dataStart || dataStart,
        dataEnd: response.data.dataEnd || dataEnd,
      });
    } catch (error) {
      setErrore(error.response?.data?.error || error.message || "Errore caricamento transazioni Domino");
    } finally {
      setLoading(false);
    }
  }, [dataEnd, dataStart, token]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const aggiungiAlPool = useCallback(async (row) => {
    if (!token) return;
    const chiave = row.tipoMovimento + "-" + row.idEntita;
    setRigheInAggiunta((previous) => ({ ...previous, [chiave]: true }));
    setErrore("");
    try {
      const response = await axios.post(
        apiUrl + "/contab/controlli-corrispettivi/transazioni-domino/aggiungi",
        { tipoMovimento: row.tipoMovimento, idEntita: row.idEntita },
        { headers: { Authorization: "Bearer " + token } },
      );
      setRows((previousRows) => previousRows.map((currentRow) =>
        currentRow.tipoMovimento === row.tipoMovimento && String(currentRow.idEntita) === String(row.idEntita)
          ? {
              ...currentRow,
              filesControllo: [...(currentRow.filesControllo || []), response.data.file],
              aggiungibileMassivamente: false,
              motivoEsclusioneMassiva: "Gia confermata in un file controllo",
            }
          : currentRow,
      ));
    } catch (error) {
      setErrore(error.response?.data?.error || error.message || "Errore aggiunta transazione al pool");
    } finally {
      setRigheInAggiunta((previous) => ({ ...previous, [chiave]: false }));
    }
  }, [token]);

  const numeroRigheAggiungibili = useMemo(
    () => rows.filter((row) => row.aggiungibileMassivamente).length,
    [rows],
  );
  const rangeCorrenteCaricato = Boolean(
    rangeCaricato &&
    rangeCaricato.dataStart === dataStart &&
    rangeCaricato.dataEnd === dataEnd
  );

  const apriAggiuntaMassiva = useCallback(() => {
    setAnalisiMassiva(null);
    setErroreAnalisiMassiva("");
    setMostraAggiuntaMassiva(true);
  }, []);

  const analizzaAggiuntaMassiva = useCallback(async () => {
    if (!token) return;
    setAnalisiMassivaInCorso(true);
    setErroreAnalisiMassiva("");
    setAnalisiMassiva(null);
    try {
      const response = await axios.get(
        apiUrl + "/contab/controlli-corrispettivi/transazioni-domino/aggiungi-massive/analisi",
        {
          headers: { Authorization: "Bearer " + token },
          params: { dataStart, dataEnd },
        },
      );
      setAnalisiMassiva(response.data);
    } catch (error) {
      setErroreAnalisiMassiva(error.response?.data?.error || error.message || "Errore analisi delle transazioni");
    } finally {
      setAnalisiMassivaInCorso(false);
    }
  }, [dataEnd, dataStart, token]);

  const aggiungiMassivamenteAlPool = useCallback(async () => {
    if (!token || !analisiMassiva || analisiMassiva.aggiungibili < 1) return;
    setAggiuntaMassivaInCorso(true);
    setErrore("");
    setMessaggio("");
    try {
      const response = await axios.post(
        apiUrl + "/contab/controlli-corrispettivi/transazioni-domino/aggiungi-massive",
        { dataStart, dataEnd },
        { headers: { Authorization: "Bearer " + token } },
      );
      setMostraAggiuntaMassiva(false);
      setAnalisiMassiva(null);
      await loadData();
      setMessaggio((response.data.aggiunte || 0) + " transazioni aggiunte al pool dei controlli");
    } catch (error) {
      setErrore(error.response?.data?.error || error.message || "Errore aggiunta massiva delle transazioni");
    } finally {
      setAggiuntaMassivaInCorso(false);
    }
  }, [analisiMassiva, dataEnd, dataStart, loadData, token]);

  const columns = useMemo(() => [
    { name: "File controllo", width: "220px", cell: (row) => <FileControlliCell files={row.filesControllo} /> },
    {
      name: "Pool", width: "145px",
      cell: (row) => {
        const chiave = row.tipoMovimento + "-" + row.idEntita;
        const giaRegistrata = Array.isArray(row.filesControllo) && row.filesControllo.length > 0;
        return giaRegistrata ? (
          <span className="colScrittaDef-20">registrata</span>
        ) : (
          <button className="dim tastoInputOrizzontale br3" type="button" disabled={Boolean(righeInAggiunta[chiave])} onClick={() => aggiungiAlPool(row)}>
            {righeInAggiunta[chiave] ? "AGGIUNGO" : "AGGIUNGI"}
          </button>
        );
      },
    },
    {
      name: "Esclusione massiva",
      selector: (row) => row.motivoEsclusioneMassiva,
      sortable: true,
      width: "320px",
      wrap: true,
      cell: (row) => row.motivoEsclusioneMassiva
        ? <span className="colScrittaDef-20">{row.motivoEsclusioneMassiva}</span>
        : <span className="tastoVerde white ph2 pv1 br2">eleggibile</span>,
    },
    {
      name: "Movimento", selector: (row) => row.tipoMovimento, sortable: true, width: "125px",
      cell: (row) => <span className={row.tipoMovimento === "RIMBORSO" ? "tastoRosso white ph2 pv1 br2" : "tastoVerde white ph2 pv1 br2"}>{row.tipoMovimento}</span>,
    },
    { name: "Data trans.", selector: (row) => row.dataTransazione, sortable: true, width: "125px", cell: (row) => formatDate(row.dataTransazione) },
    { name: "Importo", selector: (row) => row.importo, sortable: true, right: true, width: "120px", cell: (row) => formatImporto(row.importo) },
    { name: "Data partenza", selector: (row) => row.dataPartenza, sortable: true, width: "130px", cell: (row) => formatDate(row.dataPartenza) },
    { name: "Tipo", selector: (row) => row.tipoSpedizione, sortable: true, width: "130px" },
    { name: "Marketplace", selector: (row) => row.marketplace, format: row => marketplaceLabel(row.marketplace), sortable: true, width: "145px" },
    { name: "Rif. marketplace", selector: (row) => row.riferimentoMarketplace, sortable: true, width: "180px" },
    { name: "Rif. Prestashop", selector: (row) => row.riferimentoPrestashop, sortable: true, width: "150px" },
    { name: "Fonte", selector: (row) => row.fonte, sortable: true, width: "95px" },
    { name: "Partenza da", selector: (row) => row.partenzaDa, sortable: true, width: "150px" },
    { name: "Sp. sped.", selector: (row) => row.speseSpedizione, sortable: true, right: true, width: "115px", cell: (row) => formatImporto(row.speseSpedizione) },
    { name: "Sp. contrass.", selector: (row) => row.speseContrassegno, sortable: true, right: true, width: "130px", cell: (row) => formatImporto(row.speseContrassegno) },
    { name: "Pagamento", selector: (row) => row.tipoPagamento, sortable: true, width: "150px" },
    { name: "Scontrino", selector: (row) => row.emissioneScontrino, sortable: true, width: "150px" },
    { name: "Cliente", selector: (row) => row.nomeCliente, sortable: true, width: "210px" },
  ], [aggiungiAlPool, righeInAggiunta, marketplaceLabel]);

  return (
    <div className="sfondoBiancoTema pa3">
      <div className="flex flex-wrap items-center justify-between bb bordoColAlt pb3 mb3">
        <div>
          <div className="f4 b">Transazioni Domino</div>
          <div className="f6 colScrittaDef-20">Spedizioni e rimborsi nel periodo selezionato</div>
        </div>
      </div>
      {errore && <div className="tastoRosso white pa3 br2 mb3">{errore}</div>}
      {messaggio && <div className="tastoVerde white pa3 br2 mb3">{messaggio}</div>}
      <div className="formRicercaOrizzontale pa2 flex flex-wrap justify-between items-center mb3">
        <div className="flex flex-wrap items-center">
          <div className="gruppoInputRicercaOrizzontale mr2 mb2"><input className="inputOrizzontale" type="date" value={dataStart} onChange={(event) => setDataStart(event.target.value)} /></div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2"><input className="inputOrizzontale" type="date" value={dataEnd} onChange={(event) => setDataEnd(event.target.value)} /></div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2"><button className="dim tastoInputOrizzontale br3" type="button" onClick={loadData} disabled={loading}>{loading ? "CARICO" : "CERCA"}</button></div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2"><button className="dim tastoInputOrizzontale br3" type="button" onClick={() => { setDataStart(defaultRange.dataStart); setDataEnd(defaultRange.dataEnd); }}>RESET</button></div>
        </div>
        <div className="flex flex-wrap items-center justify-end mb2">
          <div className="colScrittaDef-20 mr3">Righe {rows.length} - Eleggibili {numeroRigheAggiungibili}</div>
          <button
            className="tastoVerde white br2 ph2 pv1 flex justify-center items-center"
            type="button"
            onClick={apriAggiuntaMassiva}
            disabled={loading || aggiuntaMassivaInCorso || !rangeCorrenteCaricato || rows.length < 1}
            title="Aggiungi tutte le transazioni eleggibili del periodo"
          >
            <span className="material-symbols-outlined mr1">playlist_add</span>
            AGGIUNGI ELEGGIBILI
          </button>
        </div>
      </div>
      <DataTable columns={columns} data={rows} progressPending={loading} pagination paginationPerPage={50} paginationRowsPerPageOptions={[25, 50, 100, 200]} dense highlightOnHover noDataComponent={<div className="pa4 colScrittaDef-20">Nessuna transazione nel range selezionato</div>} />
      {mostraAggiuntaMassiva && (
        <ModalAggiuntaMassiva
          dataStart={dataStart}
          dataEnd={dataEnd}
          numeroRighe={rows.length}
          analisi={analisiMassiva}
          analyzing={analisiMassivaInCorso}
          saving={aggiuntaMassivaInCorso}
          errore={erroreAnalisiMassiva}
          onAnalyze={analizzaAggiuntaMassiva}
          onConfirm={aggiungiMassivamenteAlPool}
          onClose={() => {
            setMostraAggiuntaMassiva(false);
            setAnalisiMassiva(null);
            setErroreAnalisiMassiva("");
          }}
        />
      )}
    </div>
  );
}

export default TransazioniDominoCorrispettivi;
